import { AUDIENCE_CARDS } from "../../data/home";
import type { AudienceCard } from "../../types";

export default function AudienceSection() {
  return (
    <section className="bg-fog py-24 px-5 lg:px-16" id="who-we-serve">
      <div className="max-w-6xl mx-auto">
        {/* Section label strip */}
        <div className="flex items-center gap-3 mb-5">
          <span className="font-syne text-[10px] font-bold tracking-[0.28em] uppercase text-ink-20">Who We Serve</span>
          <span className="flex-1 h-px bg-ink-10" />
        </div>
        <h2
          className="font-syne font-extrabold text-ink tracking-tight mt-1"
          style={{ fontSize: 'clamp(2.5rem,4vw,4rem)' }}
        >
          Choose{" "}
          <span style={{ color: 'transparent', WebkitTextStroke: '2px #6B35A8' }}>Your Path</span>
        </h2>
        <p className="text-ink-55 font-light text-base leading-relaxed mt-4 max-w-lg">
          Whether you're planning an intimate birthday or procuring services for a city-wide program, we have you covered.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-12">
          {AUDIENCE_CARDS.map((card) => (
            <AudienceCardComponent key={card.title} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
}

function AudienceCardComponent({ card }: { card: AudienceCard }) {
  return (
    <div
      className={`relative bg-white border rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-ink/10 ${
        card.isPrimary ? "border-violet border-2" : "border-ink-10"
      }`}
    >
      {card.isPrimary && (
        <span className="absolute top-4 right-4 bg-violet text-white text-[9px] font-syne font-bold tracking-[0.18em] uppercase px-3 py-1.5 rounded-sm">
          Most Popular
        </span>
      )}

      <div className="p-9">
        <div
          className={`text-2xl flex items-center justify-center rounded-xl w-14 h-14 mb-5 ${
            card.isPrimary ? "bg-violet/[0.12]" : "bg-gold/[0.12]"
          }`}
        >
          {card.icon}
        </div>

        <h3 className="font-syne font-bold text-ink mb-3 text-xl">{card.title}</h3>
        <p className="text-ink-55 font-light text-sm leading-relaxed">{card.description}</p>

        <div className="flex flex-wrap gap-2 mt-5">
          {card.tags.map((tag) => (
            <span
              key={tag}
              className="bg-fog text-muted font-syne text-[9.5px] font-semibold tracking-[0.1em] uppercase border border-violet/15 px-2 py-0.5 rounded-sm"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div className="px-9 py-4 bg-ivory border-t border-ink-6 flex items-center justify-between">
        <span className="text-xs text-ink-55">{card.footerNote}</span>
        <a
          href={card.footerLinkHref}
          className="text-xs font-syne font-bold tracking-wider uppercase text-violet hover:text-violet-deep transition-colors"
        >
          {card.footerLinkLabel}
        </a>
      </div>
    </div>
  );
}
